import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfessionServicesService {

  private apiUrl = environment.admin.apiUrl;
  private professionsSubject = new BehaviorSubject<any[]>([]);
  public professions$ = this.professionsSubject.asObservable();

  constructor(private http: HttpClient) {}

  /**
   * Fetch all professions with their scores
   */
  getProfessions(): Observable<any> {
    let params = {
      "queryType":"get-all-benchmarks"
    }
    return this.http.get(`${this.apiUrl}`,{params:params});
  }

  /**
   * Fetch all available subcategories
   */
  getSubCategories(): Observable<any> {
    let params = {
      "queryType":"get-all-categories"
    }
    return this.http.get(`${this.apiUrl}`,{params:params});
  }

  /**
   * Fetch all industries and their role types
   */
  getIndustries() {
    return this.http.get(`${this.apiUrl}/industries`);
  }

  /**
   * Update a profession's scores
   */
  updateProfession(profession) {
    let body = {
      ...profession,
      "flow_selected":"benchmark-update-create-profession"
    }
    return this.http.post(
      this.apiUrl,     
      body
    );
  }

  /**
   * Create a new role type within an industry
   */
  createRoleType(industry, roleType, profession) {
    let body = {
      ...profession,
      "flow_selected":"benchmark-update-create-profession"
    }
    return this.http.post(
      `${this.apiUrl}`,
      body
    );
  }

  /**
   * Update local professions cache
   */
  updateLocalProfessions(professions) {
    this.professionsSubject.next(professions);
  }

  /**
   * Get professions for a specific industry
   */
  getProfessionsByIndustry(professions, industry){
    return professions.filter(p => p.industry === industry);
  }

  //** Admin behavior category options management APIs */
  getBehaviorOptionCategories(): Observable<any> {
    let params = {
      "queryType":"get-all-behavior-option-categories"
    }
    return this.http.get(`${this.apiUrl}`,{params:params});
  }

  createOrUpdateBehaviorOptionCategory(payload: any): Observable<any> {
    const body = {
      ...payload,
      "flow_selected": "create-edit-option-category"
    };
    return this.http.post(`${this.apiUrl}`, body);
  }

  deleteBehaviorOptionCategory(categoryId: any,subcategoryId:any): Observable<any> {
    const body = {
      flow_selected: 'delete-option-category',
      categoryId: categoryId,
      subcategoryId: subcategoryId
    };
    return this.http.post(`${this.apiUrl}`, body);
  }

  deleteRoleType(industry: string, roleType: string): Observable<any> {
    return this.http.post(`${this.apiUrl}`, {
        flow_selected: 'benchmark-delete-profession',
        industry,
        roleType
    });
}

deleteIndustry(industry: string): Observable<any> {
    return this.http.post(`${this.apiUrl}`, {
        flow_selected: 'delete-industry',
        industry
    });
}
}
